// src/app/state/init-app-state.provider.ts

import { AppStateService } from './app-state.service';
import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';

export function provideAppStateInitializer(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: 'APP_STATE_INIT',
      useFactory: () => {
        const appState = inject(AppStateService);
        appState.init();
        return true;
      },
    },
  ]);
}
